module.exports = __webpack_public_path__ + "img/9f4c4c3.jpg";